var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:'view-change-fund-list view ' + _vm.className},[_c('comp-title',{attrs:{"title":_vm.title}}),_c('el-row',{staticStyle:{"padding":"10px 20px"}},[_c('asset-fund',{attrs:{"fund-info":_vm.fund,"type":"1"},on:{"fund-continue":_vm.fundChange}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }